import {
  GET_ALL_MODEL_VARIANT_DETAILS,
  MODEL_VARIANT_IS_LOADING,
  UPDATE_MODEL_VARIANT_USER_SAVE_STATUS,
  MODEL_VARIANT_MANAGEMENT_ERROR,
  SET_MODEL_VARIANT_CURRENT_PAGE,
  SET_MODEL_VARIANT_PAGE_FILTER,
  SET_MODEL_VARIANT_DETAILS,
  SET_MODEL_VARIANT_DETAILS_DUPLICATE,
  SET_MODEL_VARIANT_FILTERED_RESULTS,
  SET_MODEL_VARIANT_CHANGE,
  GET_ALL_MODEL_VARIANT_DETAILS_SEQUENCES_VERSION,
  MODEL_VARIANT_CLEANUP,
  MODELVARIANTSETPOINTS_MANAGEMENT_ERROR,
  MODELVARIANTSETPOINTS_IS_LOADING,
  GET_MODELVARIANTSETPOINTS,
  MODELVARIANTSETPOINTS_UPDATE_SAVE_STATUS,
  MODELVARIANTSETPOINTS_SET,
  MODELVARIANTSETPOINTS_SET_CHANGE,
  UPDATE_MODELVARIANTSETPOINTS_MODEL_SHOW_SCREEN,
  MODEL_VARIANT_UNITS_MANAGEMENT_ERROR,
  MODEL_VARIANT_UNITS_IS_LOADING,
  UPDATE_MODEL_VARIANT_UNITS_SAVE_STATUS,
  GET_ALL_MODEL_VARIANT_UNITS,
  SET_MODEL_VARIANT_UNITS_CHANGE,
  UPDATE_MODEL_VARIANT_UNITS_SHOW_SCREEN,
  MODEL_VARIANT_MODEL_COMPONENTS_POSITIONS_MODEL,
  
  MODEL_VARIANT_UNIT_SETPOINTS_MANAGEMENT_ERROR,
  MODEL_VARIANT_UNIT_SETPOINTS_IS_LOADING,
  GET_ALL_MODEL_VARIANT_UNIT_SETPOINTS,
  SET_MODEL_VARIANT_UNIT_SETPOINTS_DETAILS,
  SET_MODEL_VARIANT_UNIT_SETPOINTS_CHANGE,
  UPDATE_MODEL_VARIANT_UNIT_SETPOINTS_SAVE_STATUS,
  UPDATE_MODEL_VARIANT_UNIT_SETPOINTS_SHOW_SCREEN,
  SET_MODEL_VARIANT_UNITS_CLEANUP,
  SET_MODEL_VARIANT_UNITS_CURRENT_PAGE,
  SET_MODEL_VARIANT_UNITS_FILTERED_RESULTS,
  SET_MODEL_VARIANT_THRESHOLD_CURRENT_PAGE,
  SET_MODEL_VARIANT_THRESHOLD_PAGE_FILTER,
  MODEL_VARIANT_THRESHOLDS_MANAGEMENT_ERROR,
  GET_ALL_MODEL_VARIANT_DETAILS_THRESHOLDS,
  MODEL_VARIANT_THRESHOLDS_IS_LOADING,
  SET_MODEL_VARIANT_THRESHOLDS_DETAILS,
  SET_MODEL_VARIANT_THRESHOLDS_CHANGE,
  UPDATE_MODEL_VARIANT_THRESHOLDS_SHOW_SCREEN,
  UPDATE_MODEL_VARIANT_THRESHOLDS_SAVE_STATUS,

} from '../constants/index';
import { initialModelVariantState } from './initialState';

const modelVariantReducer = (state = initialModelVariantState, action) => {
  const { payload, type } = action;
  switch (type) {
    case GET_ALL_MODEL_VARIANT_DETAILS: {
      const { data } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          ...data
        }
      };
    }

    case SET_MODEL_VARIANT_CURRENT_PAGE: {
      const { currentPage } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          currentPage
        }
      };
    }

    case SET_MODEL_VARIANT_PAGE_FILTER: {
      const { filter } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          filter
        }
      };
    }

    case UPDATE_MODEL_VARIANT_USER_SAVE_STATUS: {
      const { data } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          ...data
        }
      };
    }

    case MODEL_VARIANT_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          isLoading: isLoading
        }
      };
    }

    case MODEL_VARIANT_MANAGEMENT_ERROR: {
      const { data } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          ...data
        }
      };
    }

    case SET_MODEL_VARIANT_FILTERED_RESULTS: {
      const { filteredResults } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          ...filteredResults
        }
      };
    }

    case MODEL_VARIANT_CLEANUP: {
      const { data } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          ...data
        }
      };
    }


    case SET_MODEL_VARIANT_DETAILS: {
      let { modelVariantDetails } = payload;

      let modelVariantData = modelVariantDetails.length > 0 ? modelVariantDetails[0] : state.modelVariantManager.selectedModelVariant;
      modelVariantData.Setpoints = state.modelVariantManager.selectedModelVariant.Setpoints;
      modelVariantData.Thresholds = state.modelVariantManager.selectedModelVariant.Thresholds;
      modelVariantData.ModelVariantUnit = state.modelVariantManager.selectedModelVariant.ModelVariantUnit;
      modelVariantData.ModelVariantSetpoints = state.modelVariantManager.selectedModelVariant.ModelVariantSetpoints;
      modelVariantData.PeriodicSummarySettings = state.modelVariantManager.selectedModelVariant.PeriodicSummarySettings;
      modelVariantData.ModelComponentPositions = state.modelVariantManager.selectedModelVariant.ModelComponentPositions;
      modelVariantData.ServicePlans = state.modelVariantManager.selectedModelVariant.ServicePlans;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: modelVariantData
        },
        isLoading: false,
        showBanner: false,
        isOpSuccessful: true
      };
    }

    case SET_MODEL_VARIANT_CHANGE: {
      let { selectedModelVariant } = payload;

      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: selectedModelVariant
        },
        isLoading: false,
        showBanner: false,
        isOpSuccessful: true
      };
    }

    case SET_MODEL_VARIANT_DETAILS_DUPLICATE: {
      let { modelVariantDetails, availableOrganisations } = payload;

      let modelVariantData = modelVariantDetails.length > 0 ? modelVariantDetails[0] : state.modelVariantManager.selectedModelVariant;
      modelVariantData.Setpoints = state.modelVariantManager.selectedModelVariant.Setpoints;
      modelVariantData.Thresholds = state.modelVariantManager.selectedModelVariant.Thresholds;
      modelVariantData.SequenceVersions = state.modelVariantManager.selectedModelVariant.SequenceVersions;
      modelVariantData.ModelVariantUnit = state.modelVariantManager.selectedModelVariant.ModelVariantUnit;
      modelVariantData.ModelComponentPositions = state.modelVariantManager.selectedModelVariant.ModelComponentPositions;
      modelVariantData.ServicePlans = state.modelVariantManager.selectedModelVariant.ServicePlans;
      modelVariantData.ModelVariantSetpoints = state.modelVariantManager.selectedModelVariant.ModelVariantSetpoints;
      modelVariantData.PeriodicSummarySettings = state.modelVariantManager.selectedModelVariant.PeriodicSummarySettings;
      modelVariantData.availableOrganisations = availableOrganisations || [];
      modelVariantData.ModelVariantId = 0;
      modelVariantData.UpdatedBy = '';
      modelVariantData.GuidIdentifier = '';
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: modelVariantData
        },
        isLoading: false,
        showBanner: false,
        isOpSuccessful: true
      };
    }

    case GET_ALL_MODEL_VARIANT_DETAILS_SEQUENCES_VERSION: {
      const { data } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            ...data
          }
        }
      };
    }

    case GET_MODELVARIANTSETPOINTS: {
      const { data } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            Setpoints: {
              ...state.modelVariantManager.selectedModelVariant.Setpoints,
              ...data
            }
          }
        }
      };
    }

    case MODELVARIANTSETPOINTS_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            Setpoints: {
              ...state.modelVariantManager.selectedModelVariant.Setpoints,
              isLoading: isLoading
            }
          }
        }
      };
    }

    case MODELVARIANTSETPOINTS_MANAGEMENT_ERROR: {
      const { data } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            Setpoints: {
              ...state.modelVariantManager.selectedModelVariant.Setpoints,
              ...data
            }
          }
        }
      };
    }

    case MODELVARIANTSETPOINTS_UPDATE_SAVE_STATUS: {
      const { data } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            Setpoints: {
              ...state.modelVariantManager.selectedModelVariant.Setpoints,
              ...data
            }
          }
        }
      };
    }

    case MODELVARIANTSETPOINTS_SET: {
      let { modelVariantDetailsSetpoints } = payload;

      let modelSetpointsData =
        modelVariantDetailsSetpoints.length > 0
          ? modelVariantDetailsSetpoints[0]
          : state.modelVariantManager.selectedModelVariant.Setpoints.SelectedSetpoint;

      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            Setpoints: {
              ...state.modelVariantManager.selectedModelVariant.Setpoints,
              SelectedSetpoint: {
                ...state.modelVariantManager.selectedModelVariant.Setpoints.SelectedSetpoint,
                ...modelSetpointsData
              }
            }
          }
        }
      };
    }

    case MODELVARIANTSETPOINTS_SET_CHANGE: {
      let { SelectedSetpoint } = payload;

      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            Setpoints: {
              ...state.modelVariantManager.selectedModelVariant.Setpoints,
              SelectedSetpoint: {
                ...state.modelVariantManager.selectedModelVariant.Setpoints.SelectedSetpoint,
                ...SelectedSetpoint
              }
            }
          }
        }
      };
    }

    case UPDATE_MODELVARIANTSETPOINTS_MODEL_SHOW_SCREEN: {
      const { showAddEditScreen } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            Setpoints: {
              ...state.modelVariantManager.selectedModelVariant.Setpoints,
              showAddEditScreen: showAddEditScreen
            }
          }
        }
      };
    }

    case MODEL_VARIANT_UNITS_MANAGEMENT_ERROR: {
      const { data } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            ModelVariantUnit: {
              ...state.modelVariantManager.selectedModelVariant.ModelVariantUnit,
              ...data
            }
          }
        }
      };
    }

    case MODEL_VARIANT_UNITS_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            ModelVariantUnit: {
              ...state.modelVariantManager.selectedModelVariant.ModelVariantUnit,
              isLoading: isLoading
            }
          }
        }
      };
    }

    case UPDATE_MODEL_VARIANT_UNITS_SAVE_STATUS: {
      const { data } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            ModelVariantUnit: {
              ...state.modelVariantManager.selectedModelVariant.ModelVariantUnit,
              ...data
            }
          }
        }
      };
    }

    case GET_ALL_MODEL_VARIANT_UNITS: {
      const { data } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            ModelVariantUnit: {
              ...state.modelVariantManager.selectedModelVariant.ModelVariantUnit,
              ...data
            }
          }
        }
      };
    }

    case SET_MODEL_VARIANT_UNITS_CHANGE: {
      let { SelectedModelVariantUnits } = payload;

      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            ModelVariantUnit: {
              ...state.modelVariantManager.selectedModelVariant.ModelVariantUnit,
              SelectedModelVariantUnits
            }
          }
        }
      };
    }

    case SET_MODEL_VARIANT_UNITS_CLEANUP: {
      let { modelVariantManager } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...modelVariantManager,
          selectedModelVariant: {
            ...modelVariantManager.selectedModelVariant,
            ModelVariantUnit: {
              ...modelVariantManager.selectedModelVariant.ModelVariantUnit
            }
          }
        }
      };
    }

    case SET_MODEL_VARIANT_UNITS_CURRENT_PAGE: {
      const { currentPage } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            ModelVariantUnit: {
              ...state.modelVariantManager.selectedModelVariant.ModelVariantUnit,
              currentPage
            }
          }
        }
      };
    }

    case SET_MODEL_VARIANT_UNITS_FILTERED_RESULTS: {
      const { filteredResults } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            ModelVariantUnit: {
              ...state.modelVariantManager.selectedModelVariant.ModelVariantUnit,
              ...filteredResults
            }
          }
        }
      };
    }

    case UPDATE_MODEL_VARIANT_UNITS_SHOW_SCREEN: {
      const { showAddEditScreen } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            ModelVariantUnit: {
              ...state.modelVariantManager.selectedModelVariant.ModelVariantUnit,
              showAddEditScreen: showAddEditScreen
            }
          }
        }
      };
    }

    case MODEL_VARIANT_MODEL_COMPONENTS_POSITIONS_MODEL: {
      const { data } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            ...data
          }
        }
      };
    }

    //Unit Setpoints
    case GET_ALL_MODEL_VARIANT_UNIT_SETPOINTS: {
      const { data } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            ModelVariantSetpoints: {
              ...state.modelVariantManager.selectedModelVariant.ModelVariantSetpoints,
              ...data
            }
          }
        }
      };
    }

    case MODEL_VARIANT_UNIT_SETPOINTS_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            ModelVariantSetpoints: {
              ...state.modelVariantManager.selectedModelVariant.ModelVariantSetpoints,
              isLoading: isLoading
            }
          }
        }
      };
    }

    case MODEL_VARIANT_UNIT_SETPOINTS_MANAGEMENT_ERROR: {
      const { data } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            ModelVariantSetpoints: {
              ...state.modelVariantManager.selectedModelVariant.ModelVariantSetpoints,
              ...data
            }
          }
        }
      };
    }

    case UPDATE_MODEL_VARIANT_UNIT_SETPOINTS_SAVE_STATUS: {
      const { data } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            ModelVariantSetpoints: {
              ...state.modelVariantManager.selectedModelVariant.ModelVariantSetpoints,
              ...data
            }
          }
        }
      };
    }

    case SET_MODEL_VARIANT_UNIT_SETPOINTS_DETAILS: {
      let { modelVariantSetpoints } = payload;

      let modelVariantModelVariantSetpointsData =
        modelVariantSetpoints.length > 0
          ? modelVariantSetpoints[0]
          : state.modelVariantManager.selectedModelVariant.ModelVariantSetpoints.SelectedModelVariantSetpoint;
      let isMinMaxDisabled = false;
      if (modelVariantModelVariantSetpointsData && isNaN(modelVariantModelVariantSetpointsData.DefaultValue)) {
        isMinMaxDisabled = true;
      }
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            ModelVariantSetpoints: {
              ...state.modelVariantManager.selectedModelVariant.ModelVariantSetpoints,
              SelectedModelVariantSetpoint: {
                ...state.modelVariantManager.selectedModelVariant.ModelVariantSetpoints.SelectedModelVariantSetpoint,
                ...modelVariantModelVariantSetpointsData,
                IsMinMaxDisabled: isMinMaxDisabled
              }
            }
          }
        }
      };
    }

    case SET_MODEL_VARIANT_UNIT_SETPOINTS_CHANGE: {
      let { SelectedModelVariantSetpoint } = payload;

      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            ModelVariantSetpoints: {
              ...state.modelVariantManager.selectedModelVariant.ModelVariantSetpoints,
              SelectedModelVariantSetpoint: {
                ...state.modelVariantManager.selectedModelVariant.ModelVariantSetpoints.SelectedModelVariantSetpoint,
                ...SelectedModelVariantSetpoint
              }
            }
          }
        }
      };
    }

    case UPDATE_MODEL_VARIANT_UNIT_SETPOINTS_SHOW_SCREEN: {
      const { showAddEditScreen } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            ModelVariantSetpoints: {
              ...state.modelVariantManager.selectedModelVariant.ModelVariantSetpoints,
              showAddEditScreen: showAddEditScreen
            }
          }
        }
      };
    }



    /* 
   Model VARIANT Thresholds - START
   =========================
   */

    case SET_MODEL_VARIANT_THRESHOLD_PAGE_FILTER: {
      const { filter } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            Thresholds: {
              ...state.modelVariantManager.selectedModelVariant.Thresholds,
              filter
            }
          }
        }
      };
    }

    case MODEL_VARIANT_THRESHOLDS_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            Thresholds: {
              ...state.modelVariantManager.selectedModelVariant.Thresholds,
              isLoading: isLoading
            }
          }
        }
      };
    }

    case MODEL_VARIANT_THRESHOLDS_MANAGEMENT_ERROR: {
      const { data } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            Thresholds: {
              ...state.modelVariantManager.selectedModelVariant.Thresholds,
              ...data
            }
          }
        }
      };
    }

    case UPDATE_MODEL_VARIANT_THRESHOLDS_SAVE_STATUS: {
      const { data } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            Thresholds: {
              ...state.modelVariantManager.selectedModelVariant.Thresholds,
              ...data
            }
          }
        }
      };
    }

    case UPDATE_MODEL_VARIANT_THRESHOLDS_SHOW_SCREEN: {
      const { showAddEditScreen } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            Thresholds: {
              ...state.modelVariantManager.selectedModelVariant.Thresholds,
              showAddEditScreen: showAddEditScreen
            }
          }
        }
      };
    }

    case SET_MODEL_VARIANT_THRESHOLDS_DETAILS: {
      let { modelVariantDetailThreshold } = payload;

      let modelVariantThresholdsData =
        modelVariantDetailThreshold.length > 0
          ? modelVariantDetailThreshold[0]
          : state.modelVariantManager.selectedModelVariant.Thresholds.SelectedThreshold;

      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            Thresholds: {
              ...state.modelVariantManager.selectedModelVariant.Thresholds,
              SelectedThreshold: {
                ...state.modelVariantManager.selectedModelVariant.Thresholds.SelectedThreshold,
                ...modelVariantThresholdsData
              }
            }
          }
        }
      };
    }

    case SET_MODEL_VARIANT_THRESHOLDS_CHANGE: {
      let { SelectedThreshold } = payload;

      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            Thresholds: {
              ...state.modelVariantManager.selectedModelVariant.Thresholds,
              SelectedThreshold: {
                ...state.modelVariantManager.selectedModelVariant.Thresholds.SelectedThreshold,
                ...SelectedThreshold
              }
            }
          }
        }
      };
    }

    case SET_MODEL_VARIANT_THRESHOLD_CURRENT_PAGE: {
      const { currentPage } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            Thresholds: {
              ...state.modelVariantManager.selectedModelVariant.Thresholds,
              currentPage: currentPage
            }
          }
        }
      };
    }

    case GET_ALL_MODEL_VARIANT_DETAILS_THRESHOLDS: {
      const { data } = payload;
      return {
        ...state,
        modelVariantManager: {
          ...state.modelVariantManager,
          selectedModelVariant: {
            ...state.modelVariantManager.selectedModelVariant,
            Thresholds: {
              ...state.modelVariantManager.selectedModelVariant.Thresholds,
              ...data
            }
          }
        }
      };
    }
    /*
      Model variant Thresholds - END
    */

    default:
      return state;
  }
};

export default modelVariantReducer;
